
<!-- Item selection -->
@if (items?.length > 1) {
  <div class="row">
    <div class="col-12">
      <label class="form-label" for="item-select">{{ 'bookings.calendar.selectObject' | translate }}</label>
      <select id="item-select" class="form-control form-select"
        (change)="onItemSelected($event)">
        <option [value]="null" [ngValue]="null">-</option>
        @for (item of items; track item) {
          <option
            [value]="item.id"
          [ngValue]="item.id">{{ item['name' + crtLang.toUpperCase()] }}</option>
        }
      </select>
    </div>
  </div>
}

<!-- Selected item display -->
@if (selectedItem) {
  <div class="row mt-2">
    <div class="col-12">
      <h4>{{ selectedItem['name' + crtLang.toUpperCase()] }}</h4>
      @if (selectedItem['description' + crtLang.toUpperCase()]) {
        <div class="text-pre-wrap">
          {{ selectedItem['description' + crtLang.toUpperCase()] }}
        </div>
      }
    </div>
  </div>
}
